<template>
  <span v-if="onlyDot" v-b-tooltip.hover :title="text" class="dot ml-2" :style="{ backgroundColor: dotColor }"></span>
  <span v-else class="status">
    <span class="dot" :style="{ backgroundColor: dotColor }"></span>
    <span> {{ label }} <span v-if="label">:</span> {{ text }}</span>
  </span>
</template>

<script>
export default {
  props: ["status", "onlyDot", "label"],
  computed: {
    dotColor() {
      let bgClass = "gray";
      if (this.status == "TEST") {
        bgClass = "orange";
      } else if (this.status == "PROD") {
        bgClass = "#2ECD06";
      } else if (this.status == "POST_PROD") {
        bgClass = "#9440FF";
      }
      return bgClass;
    },
    text() {
      if (this.status == "TEST") {
        return this.$t("firm.status.test");
      } else if (this.status == "PROD") {
        return this.$t("firm.status.prod");
      } else if (this.status == "POST_PROD") {
        return this.$t("firm.status.post-prod");
      }
    },
  },
};
</script>
<style scoped>
.status {
  font-weight: bold;
  padding: 5px 10px;
  background-color: rgb(233 233 233);
  border-radius: 7px;
  min-width: 100px;
}
</style>
